
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import Dashboard from '@/components/Dashboard.vue'
import Modal from '@/components/Modal.vue'
import GenericError from '@/components/GenericError.vue'
import useBasket from '@/composables/useBasket'

export default defineComponent({
  components: { Dashboard, Modal, GenericError },
  setup () {
    const router = useRouter()
    const { showBootMessage, clearLocalBasket } = useBasket()

    const tryAgain = () => {
      clearLocalBasket()
      router.push({ name: 'Journey Search' })
    }
    return {
      tryAgain,
      showBootMessage,
      clearLocalBasket
    }
  }
})
